module.exports = __webpack_public_path__ + "static/media/SmartShop_7-572w.4fc86c85.webp";